import React from "react";
import { PageBanner } from "../components/Shared";
import aimImg from "../assets/images/class/gaming.webp";
import "./InnerPages.css";

const AimObjectivePage = () => {
  return (
    <>
      <PageBanner title="Aim & Objective" breadcrumb="About / Aim & Objective" />
      <section className="section">
        <div className="container grid-2">
          <div>
            <h2 className="inner-heading">Aim & Objective</h2>
            <p className="inner-para">
              With our teachers trained by the IDPS Head office team, New Delhi,
              education at our institute isn't limited to the classroom. It
              happens throughout the campus each and every day through student
              activities.
            </p>
            <p className="inner-para">
              We follow the CBSE curriculum from class Pre Nursery to VII and the
              medium of instruction is English.
            </p>
            <p className="inner-para">
              We follow a system of continuous assessment where the academic
              success of each student is determined by their performance in
              examinations conducted throughout the academic year. At the end of
              each term, comprehensive reports are shared with the
              parents/guardians.
            </p>
            <p className="inner-para">
              We understand the use of digital technology in the delivery of
              educational content and put emphasis on e-learning habits, with all
              our classrooms equipped with Digitalized Classes. We foster our
              students' love for learning, encourage them to try new and exciting
              things, and give them a solid foundation to build on.
            </p>
          </div>
          <img
            src={aimImg}
            alt="Aim & Objective"
            className="inner-img"
          />
        </div>
      </section>
    </>
  );
};

export default AimObjectivePage;
